import {
  GET_PRODUCTOPTIONDETAIL,
  GET_PRODUCTOPTIONDETAIL_SUCCESS,
  GET_PRODUCTOPTIONDETAIL_FAIL,
  DELETE_PRODUCTOPTIONDETAIL,
  DELETE_PRODUCTOPTIONDETAIL_SUCCESS,
  DELETE_PRODUCTOPTIONDETAIL_FAIL,
  UPDATE_PRODUCTOPTIONDETAIL,
  UPDATE_PRODUCTOPTIONDETAIL_SUCCESS,
  UPDATE_PRODUCTOPTIONDETAIL_FAIL,
  ADD_NEW_PRODUCTOPTIONDETAIL,
  ADD_PRODUCTOPTIONDETAIL_SUCCESS,
  ADD_PRODUCTOPTIONDETAIL_FAIL,
  PRODUCTOPTIONDETAIL_LOADING,
  PRODUCTOPTIONDETAIL_RESET,
} from "./actionType";

export const resetProductOptionDetailState = (actionType) => ({
  type: PRODUCTOPTIONDETAIL_RESET,
  payload: { actionType },
});

export const getProductOptionDetailSuccess = (actionType, data) => ({
  type: GET_PRODUCTOPTIONDETAIL_SUCCESS,
  payload: { actionType, data },
});

export const getProductOptionDetailFail = (actionType, error) => ({
  type: GET_PRODUCTOPTIONDETAIL_FAIL,
  payload: { actionType, error },
});

export const getProductOptionDetail = data => ({
  type: GET_PRODUCTOPTIONDETAIL,
  payload: data,
});

export const getProductOptionDetailLoading = () => ({
  type: PRODUCTOPTIONDETAIL_LOADING
});

export const deleteProductOptionDetail = data => ({
  type: DELETE_PRODUCTOPTIONDETAIL,
  payload: data,
});

export const deleteProductOptionDetailSuccess = data => ({
  type: DELETE_PRODUCTOPTIONDETAIL_SUCCESS,
  payload: data,
});

export const deleteProductOptionDetailFail = error => ({
  type: DELETE_PRODUCTOPTIONDETAIL_FAIL,
  payload: error,
});

export const updateProductOptionDetail = data => ({
  type: UPDATE_PRODUCTOPTIONDETAIL,
  payload: data,
});

export const updateProductOptionDetailFail = error => ({
  type: UPDATE_PRODUCTOPTIONDETAIL_FAIL,
  payload: error,
});

export const updateProductOptionDetailSuccess = data => ({
  type: UPDATE_PRODUCTOPTIONDETAIL_SUCCESS,
  payload: data,
});

export const addNewProductOptionDetail = data => ({
  type: ADD_NEW_PRODUCTOPTIONDETAIL,
  payload: data,
});

export const addProductOptionDetailSuccess = data => ({
  type: ADD_PRODUCTOPTIONDETAIL_SUCCESS,
  payload: data,
});

export const addProductOptionDetailFail = error => ({
  type: ADD_PRODUCTOPTIONDETAIL_FAIL,
  payload: error,
});